import { Component, OnInit, ViewChild, Inject, AfterContentChecked, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { ImageCropperComponent, CropperSettings, Bounds } from 'ng2-img-cropper';

import { ProfileService } from "./profile.service";
import { SnackbarService } from "../shared/services/snackbar.service";
import { SessionStorageService } from '../shared/services/session-storage.service';
import { RestrictOutsideScrollService } from "../shared/services/restrict-outside-scroll.service";

import { config } from '../../../config/index';
import { phoneFormatInputPipe } from '../pipes/phone-formatter-input.pipe';
import { format, isValidNumber } from 'libphonenumber-js';
import { Subscription } from 'rxjs';

@Component({
	template: require('./profile.component.html'),
	styles: [require('./profile.component.less')],
	providers: [ProfileService, SnackbarService, phoneFormatInputPipe],
	preserveWhitespaces: true
})

export class ProfileComponent implements OnInit, AfterContentChecked, OnDestroy {
	formData: any;
	profileDetails: any = {
		address: {},
		dob: null
	};
	updateDetails: any;
	validation: boolean;
	roleName: any;
	role = config.role;
	baseUrl = config.photoUrl;
	valueRequired: boolean = false;
	validationClass: string = 'selector';
	locatManager: any;
	frontOffice: any;
	cooAdmin: any;
	tc: any;
	doctor: any;
	ctAdmin: any;
	superAdmin: any;
	minimumYear: any = '1900';
	maximumYear: any = new Date().getFullYear();
	languages: any[] = config.languages;
	loading: boolean;
	selectedCountry: any;
	countryCode: any;
	contactError: boolean = false;
	validationClassForCountry: string = 'selector';
	validationClassForState: string = 'selector';
	countryList: any = [];
	stateList: any = [];
	data1: any = {};
	cropperSettings1 = new CropperSettings();
	croppedHeight: any;
	croppedWidth: any;
	logoPreview: String;
	imageName: any;
	defaultRole: any = {};
	defaultLocation: any = {};
	userRoles: any = [];
	roleLocation: any = [];
	postCodeRanges: any = [];
	isTouchDevice: boolean;
	submitted: boolean= false;

	zipFormat: any =  /\b\d{5}\b/;
	postalFormat: any =  /^([a-zA-Z]\d[a-zA-Z]\s\d[a-zA-Z]\d)$/;
	zipError: boolean;
	phoneNumRegex: any =  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
	stateProvinceLabel = 'STATE';
	emailRegex: any = config.emailRegex;
	emailRegexPattern: any = config.emailRegexPattern;
	hasEmailError: boolean;

	apiSubscription: Subscription[] = [];
	getCitiesApiSubscription: Subscription;

	weekDays: any = [
		{ label: 'Monday', value: 1 },
		{ label: 'Tuesday', value: 2 },
		{ label: 'Wednesday', value: 3 },
		{ label: 'Thursday', value: 4 },
		{ label: 'Friday', value: 5 },
		{ label: 'Saturday', value: 6 },
		{ label: 'Sunday', value: 7 },
	];
	selectedWorkingDays: any = [];
	errorInWorkingDaySelection: boolean = false;

	@ViewChild('cropImage', { static: false }) cropImage: any;
	@ViewChild('cropper', { static: false }) cropper: ImageCropperComponent;

	constructor(
		private _phonepipe: phoneFormatInputPipe,
		private _profileService: ProfileService,
		private _mdlSnackbarService: SnackbarService,
		private _sessionStorageService: SessionStorageService,
		private _router: Router,
		private _restrictOutsideScrollService: RestrictOutsideScrollService,
		@Inject('utilService') private utilService: any
	) { }

	// get current crop height and width
	cropped(bounds: Bounds) {
		this.croppedHeight = bounds.bottom - bounds.top;
		this.croppedWidth = bounds.right - bounds.left;
	}

	setCropedImage = (data: any) => {
		this.logoPreview = data.image;
		let file = this.dataURItoBlob(data.image);
		this.setCurrentMediaFile(file);
		this.cropImage.close();
	}

	dataURItoBlob(dataURI: any) {
		// convert base64/URLEncoded data component to raw binary data held in a string
		var byteString;
		if (dataURI.split(',')[0].indexOf('base64') >= 0)
			byteString = atob(dataURI.split(',')[1]);
		else
			byteString = decodeURI(dataURI.split(',')[1]);

		// separate out the mime component
		var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

		// write the bytes of the string to a typed array
		var ia = new Uint8Array(byteString.length);
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}

		return new Blob([ia], { type: mimeString });
	}

	// cancel crop
	cancelCrop = () => {
		this.cropImage.close();
	}

	roleChange = (index: any) => {
		this.defaultLocation = {};
		for (var i = 0; i < this.profileDetails.roles_location.length; i++) {
			if (index === this.profileDetails.roles_location[i].role.id)
				this.roleLocation = this.profileDetails.roles_location[i].locations;
		}
	}

	ngOnInit() {
		this.locatManager = config.location_manager;
		this.frontOffice = config.front_office;
		this.cooAdmin = config.coo_admin;
		this.tc = config.tc;
		this.doctor = config.doctor;
		this.ctAdmin = config.ct_admin;
		this.superAdmin = config.super_admin;
		this._sessionStorageService.readItem(this.role).then((data: any) => {
			this.userRoles = data.roles;
			this.roleName = data.role;
		});
		this.loading = true;
		this.apiSubscription.push(this._profileService.getProfileDetails()
			.subscribe((res: any) => this.getProfileDetailsSuccessHandler(res),
				error => {
					this.loading = false;
					this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
				}));
		/* crop settings */
		this.cropperSettings1 = new CropperSettings();
		this.cropperSettings1.width = 200;
		this.cropperSettings1.height = 200;
		this.cropperSettings1.croppedWidth = 200;
		this.cropperSettings1.croppedHeight = 200;
		this.cropperSettings1.canvasWidth = 500;
		this.cropperSettings1.canvasHeight = 300;
		this.cropperSettings1.rounded = true;
		// this.cropperSettings1.minWithRelativeToResolution = false;
		this.cropperSettings1.minWidth = 40;
		this.cropperSettings1.minHeight = 10;
		this.cropperSettings1.keepAspect = true;
		this.cropperSettings1.dynamicSizing = true;
		this.cropperSettings1.cropperDrawSettings.strokeColor = 'rgba(0,0,0,1)';
		this.cropperSettings1.cropperDrawSettings.strokeWidth = 1;
		this.cropperSettings1.noFileInput = true;
		this.cropperSettings1.preserveSize = true;
		this.data1 = {};
	}

	/** To Fetch Location details **/
	getCities = () => {
		this.getCitiesApiSubscription?.unsubscribe();
		this.getCitiesApiSubscription = this._profileService.getCities()
			.subscribe((res: any) => {
				this.loading = false;
				this.getCitiesSuccessHandler(res.data);
			},
			error => {
				this.loading = false;
				this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error')
			});
	}

	getCitiesSuccessHandler(continents: any) {
		continents.forEach((continent: any) => {
			continent.countries.forEach((country: any) => {
				this.countryList.push(country);
			});
		});
		this.countryList.forEach((country: any) => {
			if (country.id === this.profileDetails.address.country_id) {
				this.stateList = country.states;
				this.selectedCountry = country;
				this.countryCode = this.selectedCountry.code;
				this.setStateLabel();
				this.stateSelected(true);
			}
		});
	}

	countrySelected() {
		this.profileDetails.address.country_id = this.selectedCountry.id;
		this.countryCode = this.selectedCountry.code;
		this.profileDetails.contact_number = '';
		this.profileDetails.address.zip = '';
		this.validateContactNumber();
		this.stateList = null;
		this.postCodeRanges = [];
		this.profileDetails.address.state_id = null;
		this.validationClassForCountry = 'selector';
		this.setStateLabel();
		this.countryList.forEach((country: any) => {
			if (country.id === this.profileDetails.address.country_id) {
				this.stateList = country.states;
			}
		})
	}

	validateContactNumber(event?: any) {
		if (this.selectedCountry) {
			this.countryCode = this.selectedCountry.code;
			this.contactError = false;
			this.setContactPipeLine(event);
			this.profileDetails.coo_country_code_id = this.selectedCountry.id;
			if (this.profileDetails.contact_number && this.countryCode) {
				if (this.countryCode === 'US' || this.countryCode === 'CA') {
					this.contactError = !this.phoneNumRegex.test(this.profileDetails.contact_number) && !isValidNumber(this.profileDetails.contact_number, this.countryCode);
				} else {
					this.contactError = this.profileDetails.contact_number.length === 3 ? false : !isValidNumber(this.profileDetails.contact_number, this.countryCode);
				}
			}
		}
	}

	setContactPipeLine(event?: any) {
        if (event) {
            let pipeValue = this._phonepipe.transform(event.target.value, this.countryCode);
            this.profileDetails.contact_number = event.target.value = pipeValue;
        } else {
            if (this.profileDetails.contact_number && (this.countryCode === 'US' || this.countryCode === 'CA')) {
                this.profileDetails.contact_number = this._phonepipe.transform(this.profileDetails.contact_number, this.countryCode);
            }
        }
    }

	getProfileDetailsSuccessHandler = (response: any) => {
		this.profileDetails = response.data;
		this.defaultRole = response.data.default_role;
		this.roleChange(this.defaultRole.id);
		this.defaultLocation = response.data.primary_location;
		this.selectedWorkingDays = response.data['tc_working_days'] ? response.data['tc_working_days'] : [];
		if (this.roleName === 'TC' && this.selectedWorkingDays.length != 0) {
			this.prefillSelectedWorkingDays();
		}
		if (!this.profileDetails.photo) {
			this.profileDetails.photo = require('../../assets/images/profile_pic.png');
		} else {
			this.profileDetails.photo = this.baseUrl + this.profileDetails.photo;
		}
		this.logoPreview = this.profileDetails.photo;
		if (this.profileDetails.year_of_birth === 0) {
			this.profileDetails.year_of_birth = null;
		}
		if (!this.profileDetails.address) {
			this.profileDetails.address = {};
		}
		if (!this.profileDetails.contact_number) {
			this.profileDetails.contact_number = '';
		}
		if (Object.keys(this.profileDetails.address).length === 0 && this.profileDetails.address.constructor === Object) {
			this.apiSubscription.push(this._profileService.getPracticeDetails()
				.subscribe((res: any) => {
					this.profileDetails.address = {
						country_id: res.data.billing_address.country_id,
						state_id: res.data.billing_address.state_id
					};
					this.getCities();
				}, error => {
					this.loading = false;
					this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
				}));
		} else {
			this.getCities();
		}
	}

    stateSelected(onLoad?: boolean) {
		if (!onLoad) {
			if (this.selectedCountry?.name.toLowerCase() === 'australia') {
				this.profileDetails.address.zip = null;
			}
		}

        this.validationClassForState = 'selector';
        this.stateList.forEach((state: any) => {
            if (state.id === this.profileDetails.address.state_id) {
                this.postCodeRanges = state.zip_code_ranges;
            }
        });
    }

    /** To set state label based on selected country */
    setStateLabel() {
        switch (this.selectedCountry.name.toLowerCase()) {
            case 'usa':
                this.stateProvinceLabel = 'STATE';
                break;
            case 'canada':
                this.stateProvinceLabel = 'PROVINCE';
                break;
            case 'australia':
                this.stateProvinceLabel = 'STATE_TERRITORY';
                break;
            default:
                this.stateProvinceLabel = 'STATE_PROVINCE';
                break;
        }
    }

    /**
     * Function to open file manager.
     */
	uploadImg = () => {
		document.getElementById('image-file-upload').click();
	}

    /**
     * Function to submit data.
     */
	_updateProfileDetails = () => {
		this.submitted = true;
		this.loading = true;
		this.updateDetails = new FormData();
		let singleRoleUsers: any = [this.ctAdmin, this.superAdmin, this.cooAdmin];

		this.validation = this.validateDetails(this.profileDetails);

		if (!this.profileDetails.address.zip || this.profileDetails.address.zip === '' || this.zipError
			|| (!this.defaultLocation?.id && singleRoleUsers.indexOf(this.roleName) === -1)) {
			this.valueRequired = true;
			this._mdlSnackbarService.showSnackbar('FILL_REQUIRED_DETAILS', 'error');
			this.loading = false;
			return;
		}
		if (this.profileDetails.photoFile) {
			this.updateDetails.append('photo', this.profileDetails.photoFile);
		}
		if (this.roleName === 'TC' && this.validateWorkingDays()) {
			this.errorInWorkingDaySelection = true;
			this.loading = false;
			return;
		}
		if (this.validation || this.roleName === this.superAdmin) {
			this.appendProfileDetails();

			this.submitProfileDetails();
		} else {
			this.loading = false;
			this._mdlSnackbarService.showSnackbar('INVALID_BIRTH_YEAR', 'error');
		}
	}

	appendProfileDetails() {
		let appendProfileDetailsArray: any = ['language', 'alternative_email', 'about_me', 'education', 'year_of_birth']
		let appendAddressArray: any = ['city', 'street_address1', 'street_address2', 'state_id', 'country_id', 'zip']
		
		appendProfileDetailsArray.forEach((element: any) => {
			if (this.profileDetails[element]) {
				this.updateDetails.append(element, this.profileDetails[element]);
			} else {
				this.updateDetails.append(element, '');
			}
		});

		appendAddressArray.forEach((element: any) => {
			if (this.profileDetails.address[element]) {
				this.updateDetails.append('address.' + element, this.profileDetails.address[element]);
			} else {
				this.updateDetails.append('address.' + element, '');
			}
		});
		if ((this.countryCode !== 'US' && this.countryCode !== 'CA')) {
			if (this.profileDetails.contact_number) {
				this.updateDetails.append('contact_number', this.profileDetails.contact_number)
			} else {
				this.updateDetails.append('contact_number', '');
			}
		}
		if (this.roleName !== this.cooAdmin && this.roleName !== this.ctAdmin && this.roleName !== this.superAdmin) {
			this.updateDetails.append('default_role_id', this.defaultRole.id);
			this.updateDetails.append('primary_location_id', this.defaultLocation.id);
		}
		if (this.roleName === 'TC') {
			this.updateDetails.append('tc_working_days', JSON.stringify(this.selectedWorkingDays));
		}
	}

	submitProfileDetails() {
		this.hasEmailError = false;
		let pattern = new RegExp(this.emailRegex);
		if (this.profileDetails.alternative_email && !pattern.test(this.profileDetails.alternative_email)) {
			this.hasEmailError = true;
		}
		this.contactError = false;
		if (this.profileDetails.contact_number) {
			if (this.selectedCountry?.name.toLowerCase() === 'australia') {
				if (this.profileDetails.contact_number.length > 3) {
					this.validateContactNumber();
				}
			} else {
				this.validateContactNumber();
			}
		}
		if (this.hasEmailError) {
			this.loading = false;
			this._mdlSnackbarService.showSnackbar('EMAIL_NOT_VALID', 'error');
		} else if (this.contactError) {
			this.loading = false;
			this._mdlSnackbarService.showSnackbar('INVALID_CONTACT_NO', 'error');
		} else {
			this.phoneFormatter();
			this.apiSubscription.push(this._profileService.submitProfileDetails(this.updateDetails)
				.subscribe((res: any) => this.submitProfileDetailsSuccessHandler(res),
					error => {
						this.loading = false;
						this._mdlSnackbarService.showSnackbar('PROFILE_NOT_UPDATED', 'error');
					}));
		}
	}

	phoneFormatter() {
		if (this.profileDetails.contact_number && (this.countryCode === 'US' || this.countryCode === 'CA')) {
			let contact_number = this._phonepipe.transform(this.profileDetails.contact_number, this.countryCode, true);
			contact_number ? this.updateDetails.append('contact_number', contact_number) : '';
		} else if (this.profileDetails.contact_number) {
			this.updateDetails.append('contact_number', this.profileDetails.contact_number);
		} else {
			this.updateDetails.append('contact_number', "");
		}
	}

	changeListener($event: any): void {
		this.cropImage.show();
		var image: any = new Image();
		var inputValue = $event.target;
		var file: File = inputValue.files[0];
		var myReader: FileReader = new FileReader();
		var that = this;
		myReader.onloadend = (e) => {
			that.imageName = file.name;
			image.src = e.target['result'];
			setTimeout(function () {
				that['cropper'].setImage(image)
			}, 100);
		}
		myReader.readAsDataURL(file);
	}

	setCurrentMediaFile(file: any) {
		this.formData = new FormData();
		this.formData.append('photo', file);
		this.profileDetails.photoFile = file;
	}

    /**
     * Function to validate data.
     * @param  {any} data.
     */
	validateDetails = (data: any) => {
		if (data.year_of_birth && this.minimumYear <= data.year_of_birth && data.year_of_birth <= this.maximumYear) {
			return true;
		} else {
			this.valueRequired = true;
			return false;
		}
	}

	submitProfileDetailsSuccessHandler = (response: any) => {
		this.loading = false;
		this._sessionStorageService.readItem(config.role).then(
			(data: any) => {
				data.photo = response.data.photo;
				data.default_role = this.userRoles.find((roleObj: any) => roleObj.role.id === this.defaultRole.id).role;
				data.primary_location = this.userRoles.find((locationObj: any) => locationObj.id === this.defaultLocation.id);
				this._sessionStorageService.saveItem(config.role, data)
					.then((data: any) => {
						this.utilService.userProfilePicUpdated.next({ profilePictureChange: true });
						this.utilService.defaultRoleChange.next({ update: true });
					});
			}
		);
		this._mdlSnackbarService.showSnackbar(response.message, 'success');
		this.submitted = false;
	}

    /**
     * Function navigate back.
     */
	backToDashboard = () => {
		this._router.navigate(['home/dashboard']);
	}

	ngAfterContentChecked() {
		this.isTouchDevice = ("ontouchstart" in document.documentElement);
	}


	zipFormatter(isZip? : boolean) {
		if (!isZip) {
			let cleaned = ('' + this.profileDetails.address.zip).replace(/\s/g, ''),
				formattedVal = cleaned;

			const zip = cleaned.substring(0, 3);
			const last = cleaned.substring(3, 6);

			if (cleaned.length > 3) {
				formattedVal = `${zip} ${last}`;
			} else if (cleaned.length > 0) {
				formattedVal = `${zip}`;
			}
			this.zipError = !this.postalFormat.test(formattedVal);

			setTimeout(() => {
				this.profileDetails.address.zip = formattedVal;
			});
		} else {
			let cleaned = ('' + this.profileDetails.address.zip).replace(/\D/g, '').slice(0, 10);
			this.zipError = !this.zipFormat.test(cleaned);

			setTimeout(() => {
				this.profileDetails.address.zip = cleaned;
			});
		}
	}

	onWorkingDaySelect(event:any, day: any) {
		if (this.selectedWorkingDays.includes(day.value) && !event) {
			this.selectedWorkingDays = this.selectedWorkingDays.filter(
				(selectedDay: any) => selectedDay !== day.value
			);
		} else {
			this.selectedWorkingDays.push(day.value);
		}
		this.errorInWorkingDaySelection = false;
	}

	prefillSelectedWorkingDays() {
		this.weekDays = this.weekDays.map((day: any) => {
			return {
				...day,
				is_selected: this.selectedWorkingDays.includes(day.value)
			};
		})
	}

	validateWorkingDays() {
		if (this.selectedWorkingDays && this.selectedWorkingDays.length === 0) {
			return true;
		} else {
			return false;
		}
	}

	ngOnDestroy() {
		this.cropImage.close();
		this.apiSubscription.forEach((subscription) => {
			subscription?.unsubscribe();
		});
		this.getCitiesApiSubscription?.unsubscribe();
		
	}
}
